/**
 * Formats an order date into a readable format.
 * Example output: "September 21, 2026"
 *
 * Expected input format: "DD/MM/YYYY" (e.g. "20/04/2026")
 * This format is first converted into "YYYY-MM-DD" to make it
 * compatible with JavaScript Date parsing.
 *
 * If the input is invalid or empty, it safely returns the original value.
 */

export const formatOrderDate = (dateString) => {
    if (!dateString) return ''

    const [day, month, year] = dateString.split('/')
    const date = new Date(`${year}-${month}-${day}`)

    if (isNaN(date.getTime())) return dateString

    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }).format(date)
    .replace(/\s+,/g, ',')
}
